import { render } from "./NotificationAdminVx.vue?vue&type=template&id=3f1c68bc&scoped=true"
import script from "./NotificationAdminVx.vue?vue&type=script&lang=js"
export * from "./NotificationAdminVx.vue?vue&type=script&lang=js"

import "./NotificationAdminVx.vue?vue&type=style&index=0&id=3f1c68bc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\TimSpule\\source\\repos\\peacoq\\Schaltzeit\\ScoutDB\\CisLogic.ScoutDB.UI.Esa\\app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f1c68bc"]])

export default __exports__